<template>
  <v-data-table
    :headers="HEADERS_COMPUTED"
    :items="produtos"
    :search="pesquisa"
    item-key="idproduto"
    :fixed-header="true"
    class="font-resp-tabela table-full-screen"
    :item-class="itemClass"
    :items-per-page="-1"
    height="calc(100vh - 213px)"
    @click:row="row => (produto_selecionado = row)"
  >
    <template #footer.page-text>
      {{ Helpers.formatarValor(produtos.length) }} itens
    </template>

    <template #top>
      <div class="d-flex align-center px-1 pt-3 pb-2">
        <span class="font-18 font-weight-medium">Produtos do pedido #{{ pedido_selecionado.idpedido }}</span>
        <v-spacer />

        <div class="w-400">
          <v-text-field
            v-model="pesquisa"
            dense
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
            class="mr-2"
          ></v-text-field>
        </div>
      </div>
    </template>

    <template #item.tipo_compra="{item}">
      <v-icon v-if="item.tipo_compra == 'TR'" title="Produto em Trânsito">
        mdi-truck
      </v-icon>
      <v-icon v-else-if="item.tipo_compra == 'FC'" title="Produto em Forecast" small>
        mdi-clock
      </v-icon>
    </template>

    <template #item.sugerido="{item}">
      {{ Helpers.formatarValor(item.sugerido) }}
    </template>

    <template #item.qtde_pedido="{item}">
      {{ Helpers.formatarValor(item.qtde_pedido) }}
    </template>

    <template #item.preco_custo="{item}">
      {{ Helpers.formatarValorMonetario(item.preco_custo) }}
    </template>

    <template #item.total="{item}">
      {{ Helpers.formatarValorMonetario(item.total) }}
    </template>
  </v-data-table>
</template>

<script>
import PedidoAPI from "./../../api/pedido";
import {logout} from "@/helpers";

export default {
  props: ["pedido_selecionado", "getItens"],
  data() {
    return {
      cabecalhos: [
        { text: "Fornecedor", value: "razao_social" },
        { text: "Cód. Interno", value: "idproduto" },
        { text: "Cód. Fornecedor", value: "cod_produto" },
        { text: "Tipo", value: "tipo_compra" },
        { text: "Descrição do produto", value: "descricao_produto" },
        { text: "Qtde. sugerida", value: "sugerido" },
        { text: "Qtde. pedido", value: "qtde_pedido" },
        { text: "Preço", value: "preco_custo" },
        { text: "Custo Total", value: "total" },
      ],
      pesquisa: '',
      produtos: [],
      produto_selecionado: {}
    };
  },
  computed: {
    HEADERS_COMPUTED() {
      let cabecalhos = this.cabecalhos;

      if (!this.pedido_selecionado.grupo_analise_fornecedor) {
        cabecalhos = cabecalhos.filter(cabecalho => (cabecalho.value !== 'razao_social'))
      }

      return cabecalhos;
    }
  },
  created() {
    this.getItensPedido();
  },
  watch: {
    getItens() {
      this.getItensPedido();
    },
    produto_selecionado() {
      this.$emit('update:produto_selecionado', this.produto_selecionado);
    }
  },
  methods: {
    itemClass(linha) {
      return {
        'text-red': linha.qtde_pedido !== linha.sugerido,
        'cursor-pointer': true,
        'sys-data-table-gray-linha': this.produto_selecionado.idproduto === linha.idproduto,
      }
    },
    getItensPedido() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        pedido: this.pedido_selecionado.idpedido,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        PedidoAPI.getItensPedido(headers, params)
          .then((response) => {
            const { token, itens_pedido } = response.data;
            localStorage.token = token;
            this.produtos = itens_pedido;

            if (this.produtos.length > 0) {
              const [primeiro_produto] = this.produtos;
              this.produto_selecionado = primeiro_produto;
            }
          })
          .catch(logout)
      );
    },
  },
};
</script>
